import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FiservCardInterface, FiservCardStatusEnum, Hint, Inscription } from '@common-fe/common-fe';
import dayjs from 'dayjs';

interface DisableActionHintWrapperProps {
  hideHint: boolean;
  hintElement: React.ReactNode;
  card?: FiservCardInterface;
  employeeLimitedAccess?: boolean;
}
const ONE_LINE_HEIGHT = 60;
const DisableActionHintWrapper = ({ hideHint, hintElement, card, employeeLimitedAccess }: DisableActionHintWrapperProps) => {
  const { t } = useTranslation();

  const numberOfDaysToReplace = useMemo(() => {
    if (!card?.mailedDate) return null;
    const mailed = dayjs(card.mailedDate).startOf('day');
    const eighthDay = mailed.add(7, 'day');
    const today = dayjs().startOf('day');
    const diff = eighthDay.diff(today, 'day');
    return diff > 0 ? diff : 0;
  }, [card?.mailedDate]);

    const labelText = useMemo(() => {
    if (employeeLimitedAccess) {
      return t('Verify your card first');
    }
    if (
      card?.status === FiservCardStatusEnum.PENDING_UNLOCK ||
      card?.status === FiservCardStatusEnum.ACTIVE
    ) {
      const dayText = numberOfDaysToReplace === 1 ? 'day' : 'days';
      return t(
        `You will be able to request a new card in ${numberOfDaysToReplace || ''} ${dayText}`
      );
    }
    return t('Your card is on its way and should arrive soon');
  }, [employeeLimitedAccess, card?.status, numberOfDaysToReplace, t]);

  return (
    <Hint
      hintAlign="bottom"
      hideHint={hideHint}
      hintElement={hintElement}
      hintHeight={ONE_LINE_HEIGHT}
      contentStyles={{
        width: 'fit-content',
        ...(employeeLimitedAccess && { marginLeft: '45px' }),
      }}
    >
      <Inscription size="12px" textAlign="center">{labelText}</Inscription>
    </Hint>
  );
};

export default DisableActionHintWrapper;